import React, { RefObject, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import SelectBox from '../../../components/SelectBox';
import { SearchOptions } from '../../../assets/styles/SearchOptions';
import Input from '../../../components/Input';
import { useRecoilValue } from 'recoil';
import { userState } from '../../../atoms';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { APPROVAL_LINE_GUBUN, COMCD_USE_YN, INIT_USE_YN_A } from '../../../_constants';
import { BtnBlue, BtnGhost, BtnRed } from '../../../components/Button';
import { InputTable } from '../../../assets/styles/InputTable';
import JobtypeOnTable from '../../sm_setting/setting12/JobtypeOnTable';
import ClickableContainer from '../../h_cctv/RealtimeCCTV/ClickableContainer';
import TableLamp from '../../../components/TableLamp';
import { useQuery } from '@tanstack/react-query';
import { apiDelete, apiGet, apiPost } from '../../../services/_common';
import TextInfoBox from '../../../components/TextInfoBox';
import SwitchToggle from '../../../components/button/SwitchToggle';
import { ButtonsWrapper } from '../../sm_setting/setting7/cctvInfoStyle';
import Portal from '../../../components/Portal';
import GroupChkModal from '../../../components/Modal/GroupChkModal';
import DeleteModal from '../../../components/Modal/DeleteModal2';
import ApprovalLineTable from '../../../components/ApprovalLineTable';
import { trimObject } from '../../../utils/trimObject';
import { toast } from 'react-toastify';
import { formatDate } from '../../../utils/formatDate';
import { useFetchCommonCodeList } from '../../../services/useSetCodeListInSelectBoxForm';
import ApprovalModal from '../../../components/Modal/ApprovalModal';
import { applyBorderStyle } from '../../../utils/applyBorderStyle';
import BackButton from '../../../components/BackButton';
import { useSetAuth } from '../../../utils/useSetAuth';
import { logPost } from '../../../services/log';
import SearchFilterModal from '../../../components/Modal/SearchFilterModal';
import useBackHistory from '../../../hooks/useBackHistory';

const Root = styled.div`
  &.hideRoot {
    visibility: hidden;
    position: absolute;
  }

  .table {
    .tbody {
      min-width: 100%;
    }
  }

  .tr {
    max-width: 100%;

    .tag {
      padding: 0.125rem 0.75rem;
      border-radius: 5px;
      color: #fff;

      &.report {
        background: var(--filled-yellow);
      }

      &.approval {
        background: var(--filled-green);
      }
    }
  }

  .w5 {
    width: 5%;
    max-width: 5%;
  }

  .w10 {
    width: 10%;
    max-width: 10%;
  }

  .w15 {
    width: 15%;
    max-width: 15%;
  }

  .w20 {
    width: 20%;
    max-width: 20%;
  }

  .w25 {
    width: 25%;
    max-width: 25%;
  }

  .w40 {
    width: 40%;
    max-width: 40%;
  }

  .w60 {
    width: 60%;
    max-width: 60%;
  }

  .filter {
    padding: 0.5rem;
    padding-bottom: 0;
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    color: var(--text-secondary);
    display: flex;
    gap: 0.5rem;
    .minWith14 {
      ul li {
        min-width: 14rem !important;
      }
    }

    .title {
      flex-shrink: 0;
      width: fit-content;
      font-weight: 600;
      margin-right: 0.5rem;
    }
    .search {
      width: 20rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      color: var(--text-secondary);
      background-color: var(--tonal-light);
      border: 1px solid var(--outline);
      border-radius: 0.25rem;
      padding: 0 0.5rem;
      input {
        padding: 0;
        font-size: 0.875rem;
        color: var(--text-secondary);
        background-color: var(--tonal-light);
        :focus {
          outline: none;
        }
      }
      .material-symbols-rounded {
        user-select: none;
        font-size: 1.375rem;
        &.close-icon {
          font-variation-settings: 'FILL' 1, 'wght' 500;
          cursor: pointer;
          font-size: 1.25rem;
          border-radius: 0.25rem;
          padding: 0.125rem;
          background-color: var(--tonal);
          &:hover {
            box-shadow: 0 0 0.25rem 0.125rem var(--tonal-deep);
          }
          &:active {
            background-color: var(--tonal-deep);
          }
          &.hidden {
            display: none;
          }
        }
      }
    }
    button {
      flex-shrink: 0;
      padding: 0 0.75rem;
      width: 4.5rem;
      height: 2.5rem;
      font-size: 0.875rem;
      border: 1px solid var(--outline);
      background-color: var(--tonal-light);
      &:hover {
        background-color: var(--tonal-deep);
      }
    }
  }

  .text-ellipsis {
    // text-overflow: ellipsis;
    // overflow: hidden;
    white-space: nowrap;
  }

  .auto-scroll {
    overflow-x: auto;
  }

  .container {
    display: block;
    white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;

    .chip {
      user-select: none;
      display: inline-block;
      vertical-align: middle; /* 자식 요소의 y축 중앙 배치를 위해 추가 */
      margin-right: 0.25rem; /* chip 간 간격 조정 */
      padding: 0.125rem 0.5rem;
      border-radius: 0.25rem;
      color: var(--text-tertiary);
      background-color: var(--tonal);
      font-size: 0.75rem;
      &.selected {
        color: var(--filled-blue-deep);
        background-color: var(--tonal-deep-blue);
      }
    }
  }

  .inputForm {
    overflow: auto;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.5rem;
    button {
      height: 2.5rem;
      font-size: 0.75rem;
      flex-shrink: 0;
      padding: 0 0.75rem;
      border-radius: 0.25rem;
    }
    button.gray {
      font-weight: 500;
      color: var(--zinc-200);
    }
    label {
      width: 5.5rem;
      font-weight: 500;
      flex-shrink: 0;
      font-size: 0.875rem;
    }
    .inputForm-group-1280 {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      @media (min-width: 1280px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;
      }
    }
    .inputForm-group-1536 {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      @media (min-width: 1536px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;
      }
    }
    .inputForm-group-1536.withBtn {
      flex-direction: row;
      gap: 0.5rem;
      button {
        transition: none;
        /* color: var(--tonal-deep); */
      }
      @media (min-width: 1536px) {
        gap: 2rem;
        button {
          margin-left: 0;
          width: fit-content;
        }
      }
    }
    .inputForm-group-1536.withBtn.inputColumnFour {
      input {
        padding: 0;
      }
    }
    .inputForm-row.labelInInput {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      flex-grow: 1;
      > div {
        flex-grow: 1;
      }
    }
    .inputForm-row.labelOutInput,
    .inputForm-row.labelInInput > div > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      input {
        flex-shrink: 1;
        height: 2.5rem;
        font-size: 0.875rem;
        padding: 0 0.5rem;
        &:disabled {
          background-color: var(--tonal);
          color: var(--text-disabled);
        }
      }
      > div.viewOnly {
        height: 2.5rem;
        font-size: 0.875rem;
        color: var(--text-primary);
        background-color: var(--tonal);
        border-radius: 0.25rem;
        padding: 0 0.75rem;
        display: flex;
        align-items: center;
      }
      > div {
        flex-grow: 1;
        > ul {
          height: 2.5rem;
          li {
            display: flex;
            width: 100%;
            max-width: 100%;
            span {
              flex-grow: 1;
              width: 4rem;
            }
          }
        }
      }
    }
    .detailInfo-group {
      margin: 1rem 0;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
      @media (min-width: 1536px) {
        grid-template-columns: repeat(3, 1fr);
      }
      .flex-col.detailInfo {
        flex-grow: 1;
        width: 100%;
        div {
          height: 2.5rem;
          color: var(--text-tertiary);
          background-color: var(--tonal);
          border-radius: 0.25rem;
          display: flex;
          align-items: center;
          padding: 0 0.5rem;
          font-size: 0.875rem;
        }
      }
    }
  }
`;

const ARRROVAL_LINES = APPROVAL_LINE_GUBUN.filter((el: any) => el.lGubun !== 'A');

const ApprovalLine = () => {
  const { t } = useTranslation();
  const { auth } = useSetAuth();
  const userInfo = useRecoilValue(userState);
  const size = useOutletContext<any>();
  const INIT_ROW_STATE = {
    lCd: '',
    lName: '',
    line1Id: [''],
    line2Id: [''],
    useYn: 'N',
    bigo: '',
    writer: '',
    wDate: '',
    editor: '',
    eDate: '',
  };
  const [isNewAdd, setIsNewAdd] = useState(true);
  const [viewTable, setViewTable] = useState<boolean>(true);
  const [openModal, setOpenModal] = useState<any>({ type: '', status: false });
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [tableData, setTableData] = useState<IApprovalLine[]>([]);
  const [isJobtypeChip, setIsJobTypeChip] = useState<boolean>(!false);
  const [list1, setList1] = useState<any[]>([]);
  const [list2, setList2] = useState<any[]>([]);
  const [selectedKey, setSelectedKey] = useState<{ [key: string]: string | null }>({ selKey: null, selKey2: null });

  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [searchOption, setSearchOption] = useState({ lName: '', line1: '' });
  const [searchOptionLineGubun, setSearchOptionLineGubun] = useState<any>({ type: 'lGubun', lGubun: 'A', cdName: t('전체') }); // 검색 - 라인구분
  const [searchOptionUseYn, setSearchOptionUseYn] = useState(INIT_USE_YN_A);
  const [lineGubun, setLineGubun] = useState<any>({ type: 'lGubun', lGubun: '', cdName: t('미선택') }); // 라인구분
  const [loading, setLoading] = useState(false);
  const [rowState, setRowState] = useState(INIT_ROW_STATE);
  const [isUseYn, setIsUseYn] = useState(false);
  const [openSubPage, setOpenSubPage] = useState(false);
  const [isThrottle, setIsThrottle] = useState<boolean>(false); // 쓰로틀링 플래그 설정

  const parentElementRef = useRef<HTMLDivElement>(null);
  const myElementRef = useRef<HTMLDivElement>(null);
  const lNameRef = useRef<HTMLInputElement>(null);

  // 사용여부 공통코드 목록 (검색조건에서 사용, 전체포함)
  const { data: useYnComCdListWithAll } = useFetchCommonCodeList(COMCD_USE_YN, true);
  const { data: capprovalList, isError, refetch } = useQuery(['/capprovalline/m_approval', userInfo.hCd], () => getCapprovalAPI(), { enabled: !!userInfo.hCd && !!userInfo.sCd });
  const { data: userPartList } = useQuery(['/user/company_approval'], () => apiGet({ path: '/user/company', req: { hCd: userInfo?.hCd } }));

  // 보고서 결재라인 리스트 조회 API
  const getCapprovalAPI = async () => {
    const req = { cCd: userInfo.hCd };
    const res = await apiGet({ path: '/capprovalline/m', req });

    if (res.status === 200) {
      return res;
    }

    return res;
  };

  // 양식지 명 너비 적용
  useEffect(() => {
    const parent = parentElementRef.current;
    const child = myElementRef.current;
    const updateTableWidth = () => {
      if (parent && child) {
        const width = parent.clientWidth - child.clientWidth;
        // setTableWidth(width);
      }
    };

    const observer = new ResizeObserver(updateTableWidth);
    if (parent) observer.observe(parent);
    if (child) observer.observe(child);

    setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => {
      if (parent) observer.unobserve(parent);
      if (child) observer.unobserve(child);
    };
  }, []);

  useEffect(() => {
    // 검색옵션 변경됐을 때 필터링 처리
    // 필터링 기준
    const filterOptions = {
      lGubun: searchOptionLineGubun.lGubun,
      lName: searchOption.lName,
      line1: searchOption.line1,
    };

    // 필터링된 어레이 리턴, 대소문자구분X
    if (capprovalList && userPartList) {
      // 사용자 아이디 찾아서 사용자 이름 새로 부여
      const newMap = capprovalList.data.data.map((item: any) => ({
        ...item,
        listName: item.line1Id.map((el: string) => userPartList.data.data.find((el2: any) => el === el2.userId)?.userName).join(' '), // '이름1 이름2'
      }));

      const filteredArray = newMap.filter((item: any) => {
        return (
          (filterOptions.lGubun === 'A' ? item : item.lGubun?.toLowerCase()?.includes(filterOptions.lGubun?.toLowerCase())) &&
          (filterOptions.lGubun === '' ? item : item.lName?.toLowerCase()?.includes(filterOptions.lName?.toLowerCase())) &&
          (filterOptions.line1 === '' ? item : item.listName?.toLowerCase()?.includes(filterOptions.line1?.toLowerCase()))
        );
      });

      const useYnFilter = YNFilter(filteredArray, 'useYn', searchOptionUseYn.USE_YN);

      if (useYnFilter.length > 0) {
        setTableData(useYnFilter);
      } else {
        setTableData([]);
      }
    }
  }, [searchOption, searchOptionLineGubun, searchOptionUseYn.USE_YN, capprovalList, userPartList]);

  const YNFilter = (initialArray: any[], key: string, option: any) => {
    if (option === 'Y') {
      return initialArray.filter((el: any) => el[key] === 'Y');
    }
    if (option === 'N') {
      return initialArray.filter((el: any) => el[key] === 'N');
    }
    return initialArray;
  };

  const renderName = (userId: string) => {
    if (userPartList) {
      const filterUser = userPartList.data.data.find((item: any) => item.userId === userId);
      return filterUser?.userName;
    }
    return userId;
  };

  // 초기화
  const initialState = () => {
    setIsNewAdd(true);
    setIsSaveClicked(false);
    setRowState(INIT_ROW_STATE);
    setSelectedIndex(null);
    setLineGubun({ type: 'lGubun', lGubun: '', cdName: '' });
    setIsUseYn(true);
    setList1([]);
    setList2([]);
  };

  // 등록 버튼 클릭
  const addBtnAction = () => {
    initialState();

    if (size.innerSize.W <= 1024) {
      setOpenSubPage(true);
    }
  };

  // 초기화 버튼 클릭
  const onClickInitiateSearchOption = () => {
    setSearchOptionUseYn(INIT_USE_YN_A);
    setSearchOption({ lName: '', line1: '' });
    setSearchOptionLineGubun({ type: 'lGubun', lGubun: 'A', cdName: '전체' });

    initialState();
  };

  // 라인 행 선택
  const onClickRow = (e: IApprovalLine, i: number) => {
    setIsNewAdd(false);
    setSelectedKey({ selKey: null, selKey2: null });

    setRowState(e);
    setIsUseYn(e.useYn === 'Y' ? !false : false);

    setLineGubun({ type: 'lGubun', lGubun: e.lGubun, cdName: e.lGubun === '1' ? '보고' : '결재' });

    const findLine = tableData?.filter((_: IApprovalLine, idx: number) => idx === i)[0];
    setList1(findLine?.line1Id);
    setList2(findLine?.line2Id[0] !== '' ? findLine?.line2Id : []);

    setSelectedIndex(i);

    if (size.innerSize.W <= 1024) {
      setOpenSubPage(true);
    }
  };

  const lGubunTagRender = (cd: string) => {
    switch (cd) {
      case '1':
        return <span className='tag report'>{t('보고')}</span>;
      case '2':
        return <span className='tag approval'>{t('결재')}</span>;
      default:
        return <span className='tag report'>{t('보고')}</span>;
    }
  };

  // 저장
  const onClickSave = async () => {
    setIsSaveClicked(true);

    if (lineGubun.lGubun === '') {
      if (!isThrottle) {
        toast.warn(t('라인구분을 선택해주세요'));
        setIsThrottle(true);
        setTimeout(() => setIsThrottle(false), 2000); // alert은 2초에 1번만 실행되게 설정
      }
      return false;
    }

    if (rowState.lName === '') {
      if (!isThrottle) {
        toast.warn(t('라인명을 입력해주세요'));
        setIsThrottle(true);
        setTimeout(() => setIsThrottle(false), 2000); // alert은 2초에 1번만 실행되게 설정
      }
      return false;
    }

    // 필수 인풋 빈 값 체크
    if (list1.length === 0) {
      if (!isThrottle) {
        toast.warn(t(`${lineGubun.lGubun === '1' ? '보고' : '결재'}라인에 사원명을 추가해주세요`));
        setIsThrottle(true);
        setTimeout(() => setIsThrottle(false), 2000); // alert은 2초에 1번만 실행되게 설정
      }
      return false;
    }

    const trimData = {
      cCd: userInfo.hCd,
      lCd: rowState.lCd,
      lGubun: lineGubun.lGubun,
      lName: rowState.lName,
      line1Id: list1.join('|'),
      line2Id: list2.join('|'),
      bigo: rowState.bigo,
      useYn: isUseYn ? 'Y' : 'N',
    };
    const req = trimObject(trimData);

    if (!isThrottle) {
      setIsThrottle(true);

      const res = await apiPost({ path: '/capprovalline/m', req });
      const { statusCode, data } = res.data;

      if (statusCode === 200) {
        setTimeout(() => setIsThrottle(false), 2000); // 2초에 한 번만 저장되게 적용
        setIsSaveClicked(false);
        setTableData(data);
        refetch();

        if (isNewAdd) {
          setRowState(data[data.length - 1]);
          setIsNewAdd(false); // 등록 후 수정모드 전환
        }

        toast.success(t(`${isNewAdd ? '저장완료' : '수정완료'}`));
        await logPost({
          hCd: userInfo.hCd,
          sCd: userInfo.sCd,
          userId: userInfo.userId,
          menu: '기타 관리 > 보고서/결재 라인 관리',
          action: '저장',
          etc: `라인명 : ${rowState.lName}`,
        });
      }
      return false;
    }
    return false;
  };

  // 삭제
  const onClickDelete = () => {
    setOpenModal({ type: 'delete', status: true, api: deleteAPI });
  };

  const deleteAPI = async () => {
    const req = {
      cCd: userInfo.hCd,
      userId: userInfo.userId,
      lCd: rowState.lCd,
    };

    const res = await apiDelete({ path: '/capprovalline/m', req });

    if (res.status === 200) {
      setTableData(res.data.data);
      addBtnAction(); // 삭제 후 등록 모드로 변경
      toast.success(t('삭제완료'));
      await logPost({
        hCd: userInfo.hCd,
        sCd: userInfo.sCd,
        userId: userInfo.userId,
        menu: '기타 관리 > 보고서/결재 라인 관리',
        action: '결재 라인 삭제',
        etc: `결재 라인 명 : ${rowState.lName}`,
      });
    }
    return false;
  };

  // 뒤로가기 버튼 클릭
  const backToMain = () => {
    initialState();
    setSelectedIndex(null);
    setOpenSubPage(false);
  };

  const { onBackPrev } = useBackHistory({ isOpen: openSubPage, onPrev: backToMain, pageName: 'approvalLine' });

  return (
    <div className={`content-container ${size.innerSize.W > 1024 ? 'twoColumn column-55 max800' : 'oneColumn'}`}>
      <Root className={size.innerSize.W > 1024 || (size.innerSize.W <= 1024 && !openSubPage) ? 'showRoot' : 'hideRoot'}>
        <SearchOptions align='left'>
          {size.innerSize.W > 1024 ? (
            <>
              <div className='inputsWrapper'>
                <div className='inputForm-row'>
                  <div className='inputForm-col withLabelComCf'>
                    <label htmlFor='lockYn'>{t('라인구분')}</label>
                    <SelectBox
                      options={APPROVAL_LINE_GUBUN}
                      defaultOption={searchOptionLineGubun.cdName}
                      state={searchOptionLineGubun}
                      setState={setSearchOptionLineGubun}
                      stateKey='lGubun'
                      initiateKey={searchOptionLineGubun.lGubun}
                      filterbar='filter-1-left'
                    />
                  </div>
                </div>
                <div className='inputForm-row'>
                  <div className='inputForm-col'>
                    <Input placeholder={t('라인명')} label='' type='text' id='lName' name='lName' state={searchOption} setState={setSearchOption} />
                  </div>
                </div>
                <div className='inputForm-row'>
                  <div className='inputForm-col'>
                    <Input placeholder={t('사원명')} label='' type='text' id='line1' name='line1' state={searchOption} setState={setSearchOption} />
                  </div>
                </div>
                <div className='inputForm-row'>
                  <div className='inputForm-col withLabelComCf'>
                    <label htmlFor='useYn'>{t('사용유무')}</label>
                    <SelectBox
                      options={useYnComCdListWithAll}
                      defaultOption={searchOptionUseYn.cdName}
                      state={searchOptionUseYn}
                      setState={setSearchOptionUseYn}
                      stateKey={COMCD_USE_YN}
                      initiateKey={searchOptionUseYn[COMCD_USE_YN]}
                      filterbar='filter-1-center'
                    />
                  </div>
                </div>
              </div>
              <div className='inputsWrapper'>
                <div className='secondSearchOption'>
                  <div className='flex-basic textBtnGroup'>
                    <BtnGhost onClick={onClickInitiateSearchOption}>{t('초기화')}</BtnGhost>
                  </div>
                  {auth.createAuth && (
                    <div className='flex-basic iconBtnGroup'>
                      <BtnGhost onClick={() => addBtnAction()}>
                        <span className='material-symbols-rounded'>add</span>
                        {t('등록')}
                      </BtnGhost>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className='filter-wrapper'>
              <div className='inputsWrapper'>
                <div className='inputForm-row' style={{ width: '100%' }}>
                  <div className='inputForm-col'>
                    <Input placeholder={t('사원명')} label='' type='search' id='line1' name='line1' state={searchOption} setState={setSearchOption} ico='search' />
                  </div>
                </div>
              </div>
              {auth.createAuth && (
                <div className='inputsWrapper'>
                  <div className='flex-basic iconBtnGroup'>
                    <BtnGhost onClick={() => addBtnAction()}>
                      <span className='material-symbols-rounded'>add</span>
                      {t('등록')}
                    </BtnGhost>
                  </div>
                </div>
              )}
            </div>
          )}
        </SearchOptions>
        <InputTable className='margin-left-05 noHorizontalScroll'>
          <div className='thead'>
            <div className='tr'>
              {/* <div className='w5 flex-center tableStickyNo'>No</div> */}
              <div className='trCol5 flex-center content-overflow'>{t('코드')}</div>
              <div className='trCol5 flex-center content-overflow'>{t('라인 구분')}</div>
              <div className='trCol10 flex-center content-overflow'>{t('라인명')}</div>
              <div className='trCol5 flex-center content-overflow'>{t('사용유무')}</div>
              <div className='trCol15 flex-center' ref={parentElementRef}>
                {t('라인순서/사원명')}
              </div>
            </div>
          </div>
          <div className='table'>
            <div className='tbody'>
              {tableData?.length > 0 ? (
                tableData.map((el: IApprovalLine, i: number) => (
                  <div
                    className={`tr ${selectedIndex === i ? 'selected' : ''}`} //
                    role='button'
                    tabIndex={0}
                    key={el.lCd}
                    onClick={() => onClickRow(el, i)}
                  >
                    {/* <div className='w5 flex-center tableStickyNo'>{i + 1}</div> */}
                    <div className='trCol5 flex-center content-overflow'>{el.lCd}</div>
                    <div className='trCol5 flex-center content-overflow'>{lGubunTagRender(el.lGubun)}</div>
                    <div className='trCol10 flex-start content-overflow'>{el.lName}</div>
                    <div className='trCol5 flex-center content-overflow'>
                      <ClickableContainer
                        onClick={() => {}} //
                        button={<TableLamp use={el.useYn === 'Y'} />}
                      />
                    </div>
                    <div className='trCol15 flex-start auto-scroll'>
                      <div className='container'>
                        {el.line1Id[0] !== '' &&
                          el.line1Id.map((item: string) => (
                            <span
                              key={item} //
                              className='chip'
                            >
                              {renderName(item)}
                            </span>
                          ))}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className='noData'>No data.</div>
              )}
            </div>
          </div>
        </InputTable>
      </Root>
      {(size.innerSize.W > 1024 || (size.innerSize.W <= 1024 && openSubPage)) && (
        <Root>
          {size.innerSize.W <= 1024 && (
            <div className='nputFormsWrapper'>
              <BackButton func={onBackPrev} />
            </div>
          )}
          <div className='inputForm'>
            {!isNewAdd && (
              <div className='inputForm-group-1536 withBtn'>
                <div className='inputForm-row labelInInput'>
                  <Input
                    label={t('코드')}
                    type='text'
                    id='lCd'
                    name='lCd'
                    state={rowState}
                    setState={setRowState}
                    disabled={!isNewAdd}
                    trim
                    // getBorderStyle={isSaveClicked ? applyBorderStyle(state.userId, 'red', 'userId') : undefined}
                  />
                </div>
              </div>
            )}
            <div className='inputForm-group-1536 withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='csCd' className='required'>
                  {t('라인구분')}
                </label>
                <SelectBox
                  options={ARRROVAL_LINES}
                  defaultOption={isNewAdd ? '미선택' : lineGubun.cdName}
                  state={lineGubun}
                  setState={setLineGubun}
                  stateKey='lGubun'
                  initiateKey={lineGubun.lGubun}
                  getBorderStyle={isSaveClicked ? applyBorderStyle(lineGubun.lGubun, 'red', 'subCd') : undefined}
                  optionHeight='height-md'
                  disabled={isNewAdd ? !auth.createAuth : !auth.updateAuth}
                />
              </div>

              <div className='inputForm-row labelInInput'>
                <SwitchToggle label='사용유무' hFor='useYn2' state={isUseYn} setState={setIsUseYn} disabled={isNewAdd ? !auth.createAuth : !auth.updateAuth} />
              </div>
            </div>

            <div className='inputForm-group-row'>
              <div className='inputForm-row labelInInput'>
                <Input
                  type='text'
                  label={t('라인명')}
                  name='lName'
                  state={rowState}
                  setState={setRowState}
                  className='required'
                  // disabled={isViewMode}
                  placeholder='라인명'
                  inputRef={lNameRef}
                  getBorderStyle={isSaveClicked ? applyBorderStyle(rowState.lName, 'red', 'smName') : undefined}
                  disabled={isNewAdd ? !auth.createAuth : !auth.updateAuth}
                />
              </div>
            </div>

            <div className='inputForm-group-row'>
              <div className='inputForm-row labelInInput'>
                <Input
                  type='text'
                  label={t('비고')}
                  name='bigo'
                  state={rowState}
                  setState={setRowState}
                  // disabled={isViewMode}
                  placeholder='비고'
                  maxLength={100}
                  disabled={isNewAdd ? !auth.createAuth : !auth.updateAuth}
                />
              </div>
            </div>

            <ApprovalLineTable gubun={lineGubun.lGubun} list1={list1} list2={list2} setList1={setList1} setList2={setList2} selectedKey={selectedKey} setSelectedKey={setSelectedKey} />

            {!isNewAdd && (
              <div className='detailInfo-group' style={{ margin: '0' }}>
                <div className='flex-col detailInfo'>
                  <label htmlFor='createDate'>{t('등록일자')}</label>
                  <div>{rowState?.wDate}</div>
                </div>
                <div className='flex-col detailInfo'>
                  <label htmlFor='createUser'>{t('등록자')}</label>
                  <div>{rowState.writer}</div>
                </div>
                <div className='flex-col detailInfo'>
                  <label htmlFor='updateDate'>{t('수정일자')}</label>
                  <div>{rowState.eDate}</div>
                </div>
                <div className='flex-col detailInfo'>
                  <label htmlFor='updateUser'>{t('수정자')}</label>
                  <div>{rowState.editor}</div>
                </div>
              </div>
            )}
          </div>

          <ButtonsWrapper>
            {!isNewAdd && auth.deleteAuth && <BtnRed onClick={onClickDelete}>{t('삭제')}</BtnRed>}
            {((isNewAdd && auth.createAuth) || auth.updateAuth) && <BtnBlue onClick={onClickSave}>{t('저장')}</BtnBlue>}
          </ButtonsWrapper>

          <Portal openModal={openModal?.status}>
            {openModal && openModal.type === 'delete' && <DeleteModal openModal={openModal} setOpenModal={setOpenModal} />}
            {openModal && openModal.type === 'chipType' && <GroupChkModal openModal={openModal} setOpenModal={setOpenModal} title={t('사용자 선택')} type='unit' comparisonList={[]} />}
          </Portal>
        </Root>
      )}
    </div>
  );
};

export default ApprovalLine;
